import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store/index'
import { auth, functions } from '@/plugins/appfirebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login')
  },
  {
    path: '/admin',
    component: () => import('@/views/Home'),
    meta: {
      isAuth: true
    },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard')
      },
      {
        path: 'accounts/email',
        name: 'Manage Email Accounts',
        component: () => import('@/views/Emails')
      },
      {
        path: 'accounts/facebook',
        name: 'Manage Facebook Accounts',
        component: () => import('@/views/Facebook')
      },
      {
        path: 'accounts/godaddy',
        name: 'Manage GoDaddy Accounts',
        component: () => import('@/views/Godaddy')
      },
      {
        path: 'accounts/paypal',
        name: 'Manage PayPal Accounts',
        component: () => import('@/views/Paypal')
      },
      {
        path: 'accounts/virtualcard',
        name: 'Manage Virtual Cards Accounts',
        component: () => import('@/views/Virtualcards')
      },
      {
        path: 'accounts/website',
        name: 'Manage Website Accounts',
        component: () => import('@/views/Website')
      },
      {
        path: 'accounts/apple',
        name: 'Manage Apple Accounts',
        component: () => import('@/views/Apple')
      },
      {
        path: 'users',
        name: 'Manage Users',
        component: () => import('@/views/Users'),
        meta: {
          isAdmin: true
        },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/Settings')
      },
    ]
  },
  { path: '*', redirect: '/admin' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// middleware
router.beforeEach((to, from, next) => {

  if(to.matched.some(record => record.meta.isAuth)) {

    auth.onAuthStateChanged( user => {

      if (!user || user.disabled == true ) {

        // if user is not logged in, then go to Login Page
        next({ path: '/login' })

      } else {
        
        user.getIdTokenResult().then( result => {

          // if user already authenticated, then set user info as below
          const getUserInfo = {
            uid: user.uid,
            username: user.displayName ? user.displayName : 'Unknown',
            photo: user.photoURL ? user.photoURL : 'unknown',
            email: user.email ? user.email : 'unknown',
            admin: result.claims ? result.claims.admin : false
          }

          // store user info on fresh start up
          Store.commit('setUser', getUserInfo)
          Store.commit('setIsAuth', true)

          // get all users into global store
          const listAllUsers = functions.httpsCallable('listAllUsers');
          listAllUsers().then(results => {
              for (let i in results.data) {
                  Store.state.users.push({
                      uid: results.data[i].uid,
                      username: results.data[i].username,
                      email: results.data[i].email
                  })
              }
          }).catch(err => { console.log(err) })

          if(to.matched.some(record => record.meta.isAdmin)) {

            if (Store.state.user.admin) {

              next();

            } else { 

              next({ path: '/admin' }) 

            }
            
          } else { next(); }

        }).catch( err => { console.log(err) }); 
        
      }
    });

  } else { next(); } 

})

export default router
